import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { McppConcept } from '../entities/mcppConcept';
import { InterfaceMcpp } from '../entities/interface-mcpp';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Observable } from '../../../../node_modules/rxjs';
import { Vars } from '../model/vars';
import { map, tap, catchError } from 'rxjs/operators';

import * as FileSaver from 'file-saver';

@Injectable()
export class McppConceptService extends BaseCrudService<McppConcept> {

  public uri = '/api/mcppConcept/';

  constructor(injector: Injector) {
    super(injector);
   // console.log('Instance McppConceptService');
  }

  buildSentence(entity?: McppConcept, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.mcppType && entity.mcppType.id) {
        query = query.concat(
          `mcppType.id${QueryOperator.Equal}${entity.mcppType.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  searchSiafMcpp(   fiscalYear: any, executingUnit: any, month: any,
    employeeType: any, payrollType, fundingSourceId: any,  bankId: any,
    employee: any, type: any,
    object: Vars): Observable<ResponsePageable<InterfaceMcpp>> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('monthId', month)
        .set('employeeTypeId', employeeType)
        .set('payrollTypeId', payrollType)
        .set('fundingSourceId', fundingSourceId)
        .set('bankId', bankId)
        .set('employeeId', employee)
        .set('type', type)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}searchSiafMcpp`;
        return this.httpClient.post<ResponsePageable<InterfaceMcpp>>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       );
    }

    fileGenerationSiafMcpp(filname: String): Observable<any> {
      const url = `${this.rutaServidor}${this.uri}interfaceSiafMcpp`;
      this.spinnerService.showAll();
      return this.httpClient.get(url, {responseType: 'blob'} )
      .pipe(
          map(res =>  {
            this.spinnerService.hideAll();
            let bean = new Blob([res], { type: 'application/txt'});
                  FileSaver.saveAs(bean, filname);
                  return bean;
              }
          ),
          catchError((err, caught) => {
              let resp = 'No se encontraron registros';
              this.spinnerService.hideAll();
              if (err.status == 404)
              this.notificationService.smallBoxWarning('Ventana de Alerta!', resp);
              return new Observable<Blob>();
              }
          )
      );
  }

  fileGenerationSiafMcppList(type: any): Observable<any> {
    const params = new HttpParams()
        .set('type', type)
    const url = `${this.rutaServidor}${this.uri}interfaceSiafMcppList`;
    this.spinnerService.showAll();
    return this.httpClient.post<InterfaceMcpp>(url, undefined, {params})
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            // console.log(response)
            return response;
          })
       );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/mcpp-concept.service.ts